export function buildRedeemAwardsPayload(redeem, session) {
  return {
    RedeemFullName: redeem.RedeemFullName,
    RedeemEmail: redeem.RedeemEmail,
    RedeemMailingAddress: [redeem.Street, redeem.Apt, redeem.City, redeem.Province, redeem.Zipcode, redeem.Country].join(','),
    RedeemBankName: redeem.BankName,
    RedeemBankClabe: redeem.BankClabe,
    RedeemBankAccount: redeem.BankAccount,
    RedeemBankBeneficiary: redeem.BankBeneficiary,
    RedeemRfc: redeem.Rfc,
    RedeemCurp: redeem.Curp,
    RedeemAwards: redeem.RedeemAwards,
    RedeemCountryAgent: session.countryUser,
    lang: session.lang,
    UserAccessToken: session.userAccessToken,
    DeviceAccessToken: session.deviceAccessToken,
    RegisterType: 'Agent'
  };
}

export function buildRedeemAward2Payload(redeem, booking, idMarivalRewardType, session) {
  return {
    RedeemFullName: redeem.RedeemFullName,
    RedeemEmail: redeem.RedeemEmail,
    GuestName: redeem.RedeemGuestName,
    Id_MarivalBooking: booking.Id_MarivalBooking,
    Id_MarivalRewardType: idMarivalRewardType,
    lang: session.lang,
    UserAccessToken: session.userAccessToken,
    DeviceAccessToken: session.deviceAccessToken,
    RegisterType: 'Agent'
  };
}
